import { success, request, invalid, failure } from "./helpers";
import {
  GET_CLIENTS_TABLE,
  GET_CLIENT_SITES,
  INVITATION_CLIENT,
  GET_INDUSTRY_OPTIONS,
  SEND_INVITATION,
  TIER_OPTIONS,
  ACCOUNT_MANAGER,
  CLIENT_OPTIONS,
  ROLLBACK_STATUS,
  SEARCH_CLIENTS,
  CLIENT_NAME,
  CREATE_CLIENT_PROFILE,
  ROLLBACK_PROFILE_STATUS,
  TEAM_MEMBER,
  GET_ALL_CLIENTS_TABLE,
  BUSINESS_UNIT_OPTIONS,
  INVITE_BUSINESS_MEMBER,
  GET_CLIENT_PROFILE,
  UPDATE_CLIENT_PROFILE,
  SUSPEND_AND_REACTIVATE,
  BUSINESS_UNITS_LIST,
  CLIENT_USERS,
  GET_BUSINESS_UNIT_TEAM_MEMBER,
  INVITATE_BUSINESS_UNIT_MEMBER,
  GET_CLIENT_TAGS,
  GET_INSIGHTS_STANDARD_CONFIG,
  RESET_STANDARD_CONFIG,
  INSIGHTS_STANDARD_CONFIG,
} from "../actions/Clients";
import { map } from "lodash";

const initialState = {
  tableData: "",
  ifInvitationClientSuccess: false,
  invitation_client_msg: "",
  industryOptions: [],
  ifSendInvitationSuccess: false,
  // for `invitations/client`
  send_invitation_error_msg: "",
  tier_options: [],
  account_manager: [],
  client_options: [],
  client_names: [],
  tableAllData: [],
  ifCreateClientProfileSuccess: false, // if create client profile success
  createClientProfileMessage: "", // create client profile error message
  teamMember_options: [], // business assign to
  businessUnitOptions: [],
  edit_client_profile: [],
  ifEditClientProfileSuccess: false,
  business_units_list: [], // for edit/Business-Units page
  ifInviteBusinessUnitMemberSuccess: false,
  ifCreateClientProfileSuccessBasic: false,
  insights_standard_config: "",
  clientId: "",
  clientProfileUpdateError: "",
};

const clients = (state = initialState, action) => {
  switch (action.type) {
    case success(GET_CLIENTS_TABLE):
      if (action.payload.data.length > 0) {
        return {
          ...state,
          tableData: action.payload,
        };
      } else {
        return {
          ...state,
          tableData: "empty",
        };
      }
    case success(GET_ALL_CLIENTS_TABLE):
      return {
        ...state,
        tableAllData: action.payload.data,
      };
    case success(SEARCH_CLIENTS):
      if (action.payload.data.length > 0) {
        return {
          ...state,
          tableData: action.payload,
        };
      } else {
        return {
          ...state,
          tableData: "empty",
        };
      }
    case success(INVITATION_CLIENT):
      return {
        ...state,
        ifInvitationClientSuccess: true,
      };
    case invalid(INVITATION_CLIENT):
      return {
        ...state,
        invitation_client_msg: action.payload.message,
      };
    case success(GET_INDUSTRY_OPTIONS):
      return {
        ...state,
        industryOptions: action.payload,
      };

    // for `invitations/client`
    case success(SEND_INVITATION):
      return {
        ...state,
        ifSendInvitationSuccess: true,
        send_invitation_error_msg: "",
      };
    case success(INVITE_BUSINESS_MEMBER):
      return {
        ...state,
        ifSendInvitationSuccess: true,
        send_invitation_error_msg: "",
      };
    // for `invitations/client`
    case invalid(SEND_INVITATION):
      return {
        ...state,
        send_invitation_error_msg: action.payload.message,
      };
    case invalid(INVITE_BUSINESS_MEMBER):
      return {
        ...state,
        send_invitation_error_msg: action.payload.message,
      };
    case success(TIER_OPTIONS):
      return {
        ...state,
        tier_options: action.payload,
      };
    case success(ACCOUNT_MANAGER):
      return {
        ...state,
        account_manager: action.payload,
      };
    case success(CLIENT_OPTIONS):
      return {
        ...state,
        client_options: action.payload,
      };
    case success(GET_CLIENT_SITES):
      const sites = [];
      map(action.payload, (site) => {
        sites.push({
          label: site.label === "Cars.com" ? "auto.com" : site.label,
          value: site.value,
          enabled: site.disabled === false,
        });
      });
      return {
        ...state,
        client_sites: sites,
      };
    case ROLLBACK_STATUS:
      return {
        ...state,
        ifSendInvitationSuccess: action.value,
        ifInviteBusinessUnitMemberSuccess: action.value,
        send_invitation_error_msg: "",
      };
    case ROLLBACK_PROFILE_STATUS:
      return {
        ...state,
        ifCreateClientProfileSuccess: false,
        ifCreateClientProfileSuccessBasic: false,
        // for the edit/Client-Profile page
        ifEditClientProfileSuccess: false,
        createClientProfileMessage: null,
      };
    case success(CLIENT_NAME):
      return {
        ...state,
        client_names: action.payload,
      };
    case success(CREATE_CLIENT_PROFILE):
      return {
        ...state,
        ifCreateClientProfileSuccessBasic: true,
        // ifCreateClientProfileSuccess: true,
        createClientProfileMessage: "",
        clientId: action.payload.clientId,
      };
    case invalid(CREATE_CLIENT_PROFILE):
    case failure(CREATE_CLIENT_PROFILE):
      return {
        ...state,
        createClientProfileMessage: action.payload.message,
      };
    case success(TEAM_MEMBER):
      return {
        ...state,
        teamMember_options: action.payload,
      };
    case success(BUSINESS_UNIT_OPTIONS):
      return {
        ...state,
        businessUnitOptions: action.payload,
      };
    // for edit/client-profile/:id
    case success(GET_CLIENT_PROFILE):
      return {
        ...state,
        edit_client_profile: action.payload,
      };
    case success(UPDATE_CLIENT_PROFILE):
      return {
        ...state,
        ifEditClientProfileSuccess: true,
        clientProfileUpdateError: "",
      };
    case invalid(UPDATE_CLIENT_PROFILE):
      return {
        ...state,
        ifEditClientProfileSuccess: false,
        clientProfileUpdateError: action.payload.message,
      };
    case success(SUSPEND_AND_REACTIVATE):
      window.location.reload();
      return {
        ...state,
      };
    case success(BUSINESS_UNITS_LIST):
      return {
        ...state,
        business_units_list: action.payload,
      };
    case success(CLIENT_USERS):
      return {
        ...state,
        client_team_members: action.payload,
      };
    case success(GET_BUSINESS_UNIT_TEAM_MEMBER):
      return {
        ...state,
        client_team_members: action.payload,
      };
    case success(INVITATE_BUSINESS_UNIT_MEMBER):
      return {
        ...state,
        ifInviteBusinessUnitMemberSuccess: true,
      };
    case invalid(INVITATE_BUSINESS_UNIT_MEMBER):
      return {
        ...state,
        send_invitation_error_msg: action.payload.message,
      };
    case request(GET_CLIENT_TAGS):
      return {
        ...state,
        client_tags_on_loading: true,
      };
    case success(GET_CLIENT_TAGS):
      return {
        ...state,
        client_tags: action.payload,
        client_tags_on_loading: false,
      };
    case success(INSIGHTS_STANDARD_CONFIG):
      return {
        ...state,
        clientId: "",
        ifCreateClientProfileSuccess: true,
      };
    case success(GET_INSIGHTS_STANDARD_CONFIG):
      return {
        ...state,
        insights_standard_config: action.payload,
      };
    case RESET_STANDARD_CONFIG:
      return {
        ...state,
        insights_standard_config: "",
      };
    default:
      return state;
  }
};

export default {
  clients,
};



// WEBPACK FOOTER //
// ./src/reducers/clients.js